import {
  gql,
  TypedDocumentNode
} from "@apollo/client";
import { fragments as addressFragments } from "/imports/api/addresses/apollo/fragments";
import { IAddressGQLResult } from "./interfaces";

export const GET_ADDRESS_WITH_ANNOTATION: TypedDocumentNode<
  { address: IAddressGQLResult }, { addressId: string, accountId?: string }
> = gql`
  query getAddressPage($addressId: String!, $accountId: String) {
    address: getAddress(addressId: $addressId, accountId: $accountId) {
      ...addressBase
      ...addressAnnotation
    }
  }
  ${addressFragments.addressBase}
  ${addressFragments.addressAnnotation}
`;

export const ANNOTATE_ADDRESS: TypedDocumentNode<
  { annotateAddress: IAddressGQLResult }, { input: any }
> = gql`
  mutation annotateAddress($input: AnnotateAddressInput!) {
    annotateAddress(input: $input) {
      ...addressBase
      ...addressAnnotation
    }
  }
  ${addressFragments.addressBase}
  ${addressFragments.addressAnnotation}
`;

export const SAVE_ADDRESS_CONTACTS = gql`
  mutation saveAddressContacts($input: SaveAddressContactsInput!) {
    saveAddressContacts(input: $input)
  }
`;

export const GET_ASIDE_INFO = gql`
  query getAddressInfo($addressId: String!) {
    address: getAddress(addressId: $addressId) {
      ...addressBase
    }
    shipments: getShipmentsForAddress(addressId: $addressId) {
      id
      number
      created {
        by
        at
      }
      direction
    }
  }
  ${addressFragments.addressBase}
`;
